import { NodeSpec } from 'prosemirror-model'

// from prosemirror-schema-basic

export const lineBreak: NodeSpec = {
  inline: true,
  group: 'inline',
  selectable: false,
  dragHandle: true,
  parseDOM: [{ tag: 'br' }],
  toDOM: () => ['br'],
}
